import NavBar from '../components/navbar/navBar';
import SkillsSection from '../components/skils';
import Footer from '../components/footer';

const SkillsPage = () => {
    return (
        <>
            <NavBar/>
            <SkillsSection skillsPage='true' />
            <Footer/>
        </>
    );
}

export default SkillsPage;
